import { Modal } from "components";
import { SearchInput } from "components/Atoms/SearchInput";
import { NoDataAvailableDiv } from "components/NoDataAvailableDiv";
import React from "react";
import { nounToLower } from "utilities/translationUtils";
import { useDebounce } from "utilities/usehooks";
import { containsAnyMergefields, getFilteredMergetopics } from "../../../exceltemplate/ColumnsPanel/utils";
import MergeTopicColumn from "./MergeTopic";

interface Props {
  sectionName: string
  availableMergeFieldTopics: server.dto.AvailableMergeFieldTopic[]
  isOpen: boolean
  onClose: () => void
  onSelect: (mergeField: string) => void
}

const SelectMergeFieldModal = (props: Props) => {
  const [searchQuery, setSearchQuery] = React.useState<string>("");
  const debouncedSearchQuery = useDebounce(searchQuery);

  const filteredMergeTopics = getFilteredMergetopics(props.availableMergeFieldTopics, debouncedSearchQuery)
    .filter(topic => containsAnyMergefields(topic));
  const hasResults = filteredMergeTopics.length > 0;

  return <Modal
    isOpen={props.isOpen}
    title={RESX.Template.MergeFieldsForSection.replace("{0}", nounToLower(props.sectionName))}
    width="large"
    height={1200}
    handleClose={() => props.onClose()}
  >
    <SearchInput
      focusOnMount
      onChange={value => { setSearchQuery(value); }}
      value={searchQuery}
      placeholder={RESX.GeneralLabels.Search}
    />
    {!hasResults && <NoDataAvailableDiv />}
    {hasResults && <div className="grow1 scrollbox-auto margin-bottom">
      <div className="flex-column gap">
        {filteredMergeTopics.map((mergeTopic) => (
          <MergeTopicColumn
            key={mergeTopic.label}
            mergeTopic={mergeTopic}
            onSelect={(mergeField) => {
              props.onSelect(mergeField);
            }}
          />
        ))}
      </div>
    </div>}
  </Modal>;
}

export default SelectMergeFieldModal;